document.addEventListener('DOMContentLoaded', () => {
  const MQ = window.matchMedia('(max-width: 1024px)');
  if (!MQ.matches) return;

  const IS_IOS_WEBKIT =
    /WebKit/.test(navigator.userAgent) &&
    /(iPhone|iPad|iPod|Macintosh).*Mobile/.test(navigator.userAgent);
  if (IS_IOS_WEBKIT && 'scrollRestoration' in history) {
    try {
      history.scrollRestoration = 'manual';
    } catch (e) {}
  }

  const galleryEl = document.getElementById('ProductGallery');
  const rebuildFromGallery = async (root) => {
    if (!galleryEl) return false;
    const list = galleryEl.querySelector('.product-gallery__list');
    if (!list) return false;
    const imgs = Array.from(list.querySelectorAll('img'));
    if (!imgs.length) return false;
    const track = root.querySelector('.p-media__track');
    const nextSrcs = imgs.map((img) => img.currentSrc || img.src);
    const currentImgs = Array.from(track.querySelectorAll('.p-media__img'));
    const currentSrcs = currentImgs.map((el) => el.currentSrc || el.src);
    const isSame =
      currentSrcs.length === nextSrcs.length &&
      currentSrcs.every((src, i) => src === nextSrcs[i]);
    if (isSame) return false;

    const firstSrc = imgs[0].currentSrc || imgs[0].src;
    const preloadImg = new Image();
    preloadImg.src = firstSrc;

    if (!preloadImg.complete) {
      await new Promise((resolve) => {
        preloadImg.onload = resolve;
        preloadImg.onerror = resolve;
        setTimeout(resolve, 100);
      });
    }

    track.innerHTML = imgs
      .map((img, i) => {
        const src = img.currentSrc || img.src;
        const alt = img.alt || '';
        const eager = i === 0;
        const loading = eager ? 'eager' : 'lazy';
        const decoding = eager ? 'sync' : 'async';
        const fetchpriority = eager ? ' fetchpriority="high"' : '';
        return `<figure class=\"p-media__slide\"><img class=\"p-media__img\" src=\"${src}\" alt=\"${alt}\" loading=\"${loading}\" decoding=\"${decoding}\"${fetchpriority}></figure>`;
      })
      .join('');
    return true;
  };

  document.querySelectorAll('.p-media').forEach(async (root) => {
    await rebuildFromGallery(root);
    initSlider(root);
  });

  function initSlider(root) {
    const track = root.querySelector('.p-media__track');
    const initialSlides = Array.from(track.querySelectorAll('.p-media__slide'));
    const dotsWrap = root.querySelector('.p-media__dots');
    const slidesCount = () => track.querySelectorAll('.p-media__slide').length;
    if (!initialSlides.length) return;

    track.style.overflowAnchor = 'none';

    dotsWrap.innerHTML = '<span class="p-media__indicator"></span>';
    const indicator = dotsWrap.querySelector('.p-media__indicator');

    let index = 0;
    const updateIndicator = () => {
      const totalSlides = slidesCount();
      if (totalSlides === 0 || !indicator) return;

      const maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll === 0) {
        indicator.style.width = `100%`;
        indicator.style.left = `0%`;
        return;
      }

      const scrollProgress = Math.max(
        0,
        Math.min(1, track.scrollLeft / maxScroll)
      );

      const indicatorWidth = 100 / totalSlides;

      const maxPosition = 100 - indicatorWidth;
      const indicatorLeft = scrollProgress * maxPosition;

      indicator.style.width = `${indicatorWidth}%`;
      indicator.style.left = `${indicatorLeft}%`;
    };

    const setActive = (i) => {
      index = i;
      updateIndicator();
    };

    const width = () => track.clientWidth;
    const to = (i, smooth = true) => {
      const count = Math.max(1, slidesCount());
      index = ((i % count) + count) % count;
      track.scrollTo({
        left: index * width(),
        behavior: smooth ? 'smooth' : 'auto',
      });
      setActive(index);
    };

    let tid;
    let hideIndicatorTimeout;

    const showIndicator = () => {
      if (!indicator) return;
      indicator.classList.add('is-visible');

      clearTimeout(hideIndicatorTimeout);
      hideIndicatorTimeout = setTimeout(() => {
        if (indicator) {
          indicator.classList.remove('is-visible');
        }
      }, 1000);
    };

    track.addEventListener(
      'scroll',
      () => {
        updateIndicator();
        showIndicator();

        clearTimeout(tid);
        tid = setTimeout(() => {
          const i = Math.round(track.scrollLeft / width());
          if (i !== index) {
            index = i;
          }
        }, 80);
      },
      { passive: true }
    );

    setActive(0);
    track.classList.add('is-ready');

    if (IS_IOS_WEBKIT) {
      const ensureFirstVisible = () => {
        to(0, false);
        track.scrollLeft = 0;
      };
      requestAnimationFrame(ensureFirstVisible);
      window.addEventListener('pageshow', (e) => {
        if (e && e.persisted) ensureFirstVisible();
      });
      const firstImg = track.querySelector('.p-media__img');
      if (firstImg) {
        if (!firstImg.complete) {
          firstImg.addEventListener(
            'load',
            () => setTimeout(ensureFirstVisible, 0),
            { once: true }
          );
        }
        try {
          if (typeof firstImg.decode === 'function') {
            firstImg
              .decode()
              .then(() => setTimeout(ensureFirstVisible, 0))
              .catch(() => setTimeout(ensureFirstVisible, 0));
          }
        } catch (_) {}
      }
      window.addEventListener('load', () => setTimeout(ensureFirstVisible, 0), {
        once: true,
      });
    }

    window.addEventListener('resize', () => to(index, false));

    root.addEventListener('pmedia:reset', () => {
      index = 0;
      setActive(0);
    });
  }
  let reinitPending = false;
  const reinit = () => {
    if (reinitPending) return;
    reinitPending = true;

    requestAnimationFrame(async () => {
      const roots = Array.from(document.querySelectorAll('.p-media'));

      for (const root of roots) {
        const changed = await rebuildFromGallery(root);
        if (!changed) continue;
        const track = root.querySelector('.p-media__track');

        track.scrollLeft = 0;
        track.scrollTo({ left: 0, behavior: 'auto' });

        root.dispatchEvent(new CustomEvent('pmedia:reset'));

        if (IS_IOS_WEBKIT) {
          setTimeout(() => {
            track.scrollLeft = 0;
            track.scrollTo({ left: 0, behavior: 'auto' });
          }, 0);
          setTimeout(() => {
            track.scrollLeft = 0;
          }, 50);
        }
      }

      reinitPending = false;
    });
  };

  document.addEventListener('variant:change', reinit);

  if (galleryEl) {
    let t;
    const obs = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(reinit, 0);
    });
    obs.observe(galleryEl, {
      attributes: true,
      attributeFilter: ['data-current-color'],
      childList: true,
      subtree: true,
    });
  }

  const form =
    document.getElementById('add-to-cart-form') ||
    document.querySelector('[data-product-form]') ||
    document.querySelector('form[action*="/cart/add"]');
  const idInput = form ? form.querySelector('[data-variant-input]') : null;
  if (idInput) {
    idInput.addEventListener('change', reinit);
    const idObs = new MutationObserver(reinit);
    idObs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }
});
